import * as React from "react";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
      super(props);
      this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
      // You can also log the error to an error reporting service
      console.error(error, errorInfo);
    }

    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <ErrorMessage />;
      }

      return this.props.children;
    }
  }

  interface Props {
 children: React.ReactNode;
  }

  interface State {
      hasError: boolean;
  }